export default __webpack_public_path__ + "static/media/img-0145-india-full-face.4f27dce5.png";